export default __webpack_public_path__ + "static/contact-20fad4aaf0d3c7766916548045cbf0db.png";